import { configureStore } from "@reduxjs/toolkit";

// masters reducer
import masters from "./masters";

import settings from "../features/settings/Slice";

//blogs reducer
import blogs from "./blogs";

//Aboutus
import aboutus from "./aboutus";

//Customizations
import customizations from "./customizations";

//Privacy policys
import privacypolicys from "./privacypolicys";

//terms of services
import termsofservices from "./termsofservices";

//home page
import homepage from "./homepage";

//dashboard
import dashboard from "./dashboard";

//contactuss
import contactuss from "./contactuss";

//effects
import effects from "./effects";

//product enquiry
import product_enquirys from "./product_enquirys";

//gallery show
import galleryshow from "./galleryshow";

export const store = configureStore({
  reducer: {
    masters,

    blogs,

    aboutus,
    customizations,

    privacypolicys,
    termsofservices,
    homepage,

    dashboard,
    contactuss,

    settings,

    effects,
    product_enquirys,
    galleryshow,
  },
});
